import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';
import * as CellRenderers from './AgGridCellRendererComponents';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const jobColumns = [
  { headerName: 'Invoice #', field: 'jobNum', sortable: true, width: 100 },
  {
    headerName: 'Date',
    field: 'jobDateTime',
    cellRenderer: 'jobDateCellRenderer',
    sortable: true,
    width: 150,
  },
  { headerName: 'Clm #', field: 'clmClaimNumber', sortable: true, width: 150 },
  { headerName: 'Claimant', field: 'clmLastName', sortable: true, width: 150 },
  { headerName: 'Client', field: 'clientName', sortable: true, width: 150 },
  { headerName: 'Provider', field: 'providerName', sortable: true, width: 150 },
  { headerName: 'IntFee', field: 'intFee', sortable: true, width: 100 },
  { headerName: 'Overtime', field: 'intOTFee', sortable: true, width: 100 },
  {
    headerName: 'OtherIntFee',
    field: 'intFeeOther',
    sortable: true,
    width: 100,
  },
];

export class InterpreterTableJobs extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: jobColumns,
      rowData: this.props.jobList,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        setModalWorkOrder: this.setModalWorkOrder,
        viewInvoice: this.viewInvoice,
        state: this.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      componentsw: {
        // Register the cell renderer
        jobNumCellRenderer: CellRenderers.JobNumCellRenderer,
        jobDateCellRenderer: JobDateCellRenderer,
        clmNameCelRenderer: ClmNameCellRenderer,
      },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: (params) =>
        this.props.viewWorkOrder(params, true),
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '300px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

class ClmNameCellRenderer extends Component {
  render() {
    const { data } = this.props; // ag-Grid passes the data prop automatically to the renderer
    const name =
      `${data.clmLastName}, ${data.clmFirstName},` +
      '(' +
      `${data.clientAbbrv}` +
      ')';

    if (data.hasClaimantDupWO) {
      return <span style={{ color: 'red' }}>{name}</span>;
    } else {
      return <span>{name}</span>;
    }
  }
}

class JobDateCellRenderer extends React.Component {
  render() {
    const { data } = this.props;
    const formattedJobDate = moment(data.jobDateTime).format('MM/DD/YYYY');
    const formattedFinishTime = data.finishTime
      ? ` to ${moment(data.finishTime).format('hh:mm A')}`
      : '';
    const jobStatus = data.FailedFlg ? ' (Failed)' : ' (Success)';

    return (
      <div className="x-grid-cell-inner">
        {formattedJobDate}
        {formattedFinishTime}
        {jobStatus}
      </div>
    );
  }
}
